import React, {useState} from "react";
import "./EmailInput.css"

export const EmailInput = ({email, setEmail, handleFinalSubmit, checkboxStates, setCheckboxStates}) => {

    const handleCheckboxChange = (checkboxId) => {
        setCheckboxStates(prevState => {
            return {
                ...prevState,
                [checkboxId]: !prevState[checkboxId]
            }
        });
    }

    return (
        <>
            <h1 className={"extra_text"}>Explorez la voyance par e-mail qui vous est réservée.</h1>
            <input className={"input"} type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Addresse email"/>
            <div className="checkbox-container">
                <input type="checkbox" id="checkbox1" checked={checkboxStates.cguAgreed} onChange={() => handleCheckboxChange("cguAgreed")} />
                <label htmlFor="checkbox1">J'ai lu et j'accepte les <a href={"https://www.voyance.fm/cgu/"}>mentions légales</a> d'Irina Voyance</label>
            </div>
            <div className="checkbox-container" style={{marginBottom: "2%"}}>
                <input type="checkbox" id="checkbox2" checked={checkboxStates.consentAgreed} onChange={() => handleCheckboxChange("consentAgreed")} />
                <label htmlFor="checkbox2">Donnes-tu ton consentement exprès<sup className={"index"}>(2)</sup> pour recevoir des offres de voyance par téléphone, email, SMS ou WhatsApp ?</label>
            </div>
            <button className={!email || !checkboxStates.cguAgreed ? "disabled-button" : "button"}
                    disabled={!email || !checkboxStates.cguAgreed || !checkboxStates.consentAgreed} onClick={handleFinalSubmit}>OBTENEZ LA VOYANCE GRATUITE</button>
        </>
    )
}
